module.exports = __webpack_public_path__ + "static/media/AdmissionsMgmt.9b0cf8f5.svg";